import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useSWRMutation from 'swr/mutation'

import { uploadAndAnalyzeCV } from '../../../api/cv-roaster'
import { CVRoasterResult } from '../../../api/cv-roaster/types'
import CVUploader from '../../components/cv-roaster/CVUploader'
import CVResults from '../../components/cv-roaster/CVResults'
import { useI18N } from '../../../libraries/i18n/hook'
import MasterStudioAIPage, { STUDIO_AI_TABS } from './Master'
import Button from '../../components/form/Button'
import PlusIcon from '../../../assets/icons/plus.svg?react'
import AiDisclaimer from '../../components/ai/Disclaimer'

const CVRoaster: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const initialResultFromState = (location.state as { result?: CVRoasterResult } | null)?.result ?? null
  const [result, setResult] = useState<CVRoasterResult | null>(initialResultFromState)
  const { t } = useI18N()

  const { trigger: triggerUploadAndAnalyze, isMutating, error: uploadError } = useSWRMutation(
    '/cv-roaster',
    uploadAndAnalyzeCV,
    {
      onSuccess: (data) => {
        setResult(data)
      }
    }
  )

  const handleUpload = async (file: File) => {
    await triggerUploadAndAnalyze({ file })
  }

  const clearCVResults = () => {
    navigate('/cv-roaster', { replace: true })
  }

  const NewCVButton = (
    <Button className='' icon={<PlusIcon />} variant='flat' outlined onClick={clearCVResults} size='lg' />
  )

  return (
    <MasterStudioAIPage activeTab={STUDIO_AI_TABS.CV_ROASTER} buttons={result ? NewCVButton : null}>
      <div className='mx-auto min-h-[80vh] lg:min-h-[75vh] px-4'>
        {!result && (
          <p className='my-[7vh] text-sm sm:text-md font-normal mx-auto text-center max-w-3xl'>
            {t('cv.page.description')}
          </p>
        )}

        {!result && <CVUploader onUpload={handleUpload} isUploading={isMutating} uploadError={uploadError} />}

        {result && <CVResults title={t('cv.analysis.results')} feedbackTitle={t('cv.points.improvement')} result={result} newButton={{ label: t('cv.analysis.new'), onClick: () => navigate('/cv-roaster', { replace: true }) }} />}
        {!result && <div className='max-w-4xl mx-auto' ><AiDisclaimer /></div>}
      </div>
    </MasterStudioAIPage>
  )
}

export default CVRoaster
